module.exports = __webpack_public_path__ + "img/jackpot.9a07ea17.png";